import { ZepIcon_default } from './chunk-SGEFWXJL.mjs';
import { jsxs, jsx } from 'react/jsx-runtime';

var EyeSlashIcon = ZepIcon_default((props) => /* @__PURE__ */ jsxs("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", ...props, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M4.826 7.876c-1.058.98-1.986 2.208-2.72 3.677a1 1 0 0 0 0 .894C4.264 16.764 8.096 19 12 19c1.145 0 2.284-.192 3.377-.574l-1.618-1.617A8.209 8.209 0 0 1 12 17c-2.969 0-6.002-1.62-7.87-5a10.538 10.538 0 0 1 2.112-2.709L4.826 7.876ZM11.05 7.055 9.346 5.351C10.214 5.118 11.106 5 12 5c3.903 0 7.736 2.236 9.894 6.553a1 1 0 0 1 0 .894 12.957 12.957 0 0 1-2.243 3.209l-1.414-1.414A10.777 10.777 0 0 0 19.87 12C18.002 8.62 14.97 7 12 7c-.316 0-.633.018-.95.055Z",
      fill: props.fill || "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M8.092 11.142a4 4 0 0 0 4.766 4.766l-4.766-4.766ZM16 12.005 11.995 8H12a4 4 0 0 1 4 4v.005ZM2.707 3.707a1 1 0 1 1 1.414-1.414l16.97 16.97a1 1 0 0 1-1.413 1.415L2.708 3.708Z",
      fill: props.fill || "currentColor"
    }
  )
] }));

export { EyeSlashIcon };
